import React from "react";
import classNames from "classnames";
import {
  Alert,
  Badge,
  Form,
  Tag,
  Icon,
  Input,
  InputNumber,
  Button,
  Row,
  Col,
  Select,
  Tooltip,
  Switch,
  message,
  DatePicker,
  Checkbox,
} from "antd";
import { DeleteOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { LoadingOutlined } from "@ant-design/icons";

import get from "lodash/get";
import find from "lodash/find";
import map from "lodash/map";
import filter from "lodash/filter";
import { connect } from "react-redux";

import {
  updateFinanceInvoiceRequest,
  createFinanceInvoiceRequest,
  financeExchange,
  getFinanceInvoiceEventItemListRequest,
  createFinanceInvoiceItemRequest,
  deleteFinanceInvoiceItemRequest,
  activateFinanceInvoiceItemRequest,
  updateFinanceInvoiceItemRequest,
  deleteFinanceInvoiceEventItemRequest,
  activateFinanceInvoiceEventItemRequest,
} from "../../api/requests";

import {
  getFinanceInvoiceCreatePermission,
  getFinanceInvoiceUpdatePermission,
} from "../../reducers/user/selectors";

import classes from "./FinanceInvoiceForm.css";
import { logout } from "../../reducers/user/actions";
import moment from "moment-timezone";
import { withNamespaces } from "react-i18next";

const { Option } = Select;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

const currencies = ["CAD", "USD", "EUR", "AUD"];

class FinanceInvoiceForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requestResult: {},
      showID: false,
      items: props.items || [],
      eventItems: [],
      isEvents: false,
      exchange: {},
      exchangeError: null,
      isLoadingInvoice: false,
      loadingEventId: null,
      attached_event_ids: [],
    };
  }

  componentDidMount() {
    this.financeExchange();
    if (this.props.id) {
      this.getFinanceInvoiceEventItemListRequest();
    }
  }

  getFinanceInvoiceEventItemListRequest = async () => {
    if (this.props.id) {
      this.setState({ isLoadingInvoice: true });
      setTimeout(async () => {
        try {
          const { data } = await getFinanceInvoiceEventItemListRequest({
            id: this.props.id,
            site_id: this.props.form.getFieldValue("site_id"),
          });
          this.setState({ eventItems: data });
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          console.log(e);
        }

        this.setState({ isLoadingInvoice: false });
      }, 0);
    }
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      const items = values.items;

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const invoice = { ...values };

          if (values.invoice_date) {
            invoice.invoice_date = values.invoice_date.format(
              "YYYY-MM-DDT23:59"
            );
          }

          if (values.payment_due_date) {
            invoice.payment_due_date = values.payment_due_date.format(
              "YYYY-MM-DDT23:59"
            );
          }

          delete invoice.items;

          let result;

          if (this.props.id) {
            await updateFinanceInvoiceRequest(this.props.id, invoice);
          } else {
            result = await createFinanceInvoiceRequest(invoice);
          }

          if (items && items.length > 0) {
            await Promise.all(
              items
                .filter((item) => item !== null)
                .map((item) => {
                  if (item.id) {
                    return updateFinanceInvoiceItemRequest({
                      invoiceId: this.props.id || get(result, "data.id"),
                      itemId: item.id,
                      item,
                    });
                  } else {
                    return createFinanceInvoiceItemRequest({
                      invoiceId: this.props.id || get(result, "data.id"),
                      item,
                    });
                  }
                })
            );
          }

          this.setState({
            isLoading: false,
            requestResult: { type: "success", message: this.props.i18n.t("Success") },
          });

          setTimeout(() => {
            this.props.onSubmit(this.props.id);
          }, 1000);
        } catch (e) {
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", this.props.i18n.t("Error")),
            },
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      }
    });
  };

  financeExchange = () => {
    setTimeout(async () => {
      const fromCurrency = this.props.form.getFieldValue("currency");
      const toCurrency = this.props.form.getFieldValue("local_currency");

      if (fromCurrency && toCurrency) {
        this.setState({
          exchange: null,
          exchangeError: null,
        });

        try {
          const { data } = await financeExchange({
            fromCurrency,
            toCurrency,
          });

          this.setState({
            exchange: data,
            exchangeError: null,
          });
        } catch (e) {
          this.setState({
            exchangeError: get(e, "response.data.error"),
          });
        }
      }
    }, 0);
  };

  onSwitchInvoiceActivation = (itemId, state, positionIndex) => async () => {
    try {
      const items = [...this.state.items];

      if (state === "active") {
        await deleteFinanceInvoiceItemRequest({
          invoiceId: this.props.id,
          itemId,
        });
        items[positionIndex].state = "inactive";
      } else {
        await activateFinanceInvoiceItemRequest({
          invoiceId: this.props.id,
          itemId,
        });
        items[positionIndex].state = "active";
      }

      message.success("Saved");

      this.setState({ items: [...items] });

      this.getSubtotal();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error("Error");
      console.log(e);
    }
  };

  onSwitchInvoiceEventTypeActivation = (
    itemId,
    state,
    positionIndex
  ) => async () => {
    try {
      if (state === "active") {
        await deleteFinanceInvoiceEventItemRequest({
          invoiceId: this.props.id,
          itemId,
        });
      } else {
        await activateFinanceInvoiceEventItemRequest({
          invoiceId: this.props.id,
          itemId,
        });
      }

      this.getFinanceInvoiceEventItemListRequest();

      message.success("Saved");

      this.getSubtotal();
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
      message.error("Error");
      console.log(e);
    }
  };

  getSubtotalNum() {
    const { items } = this.props.form.getFieldsValue();
    const { eventItems } = this.state;

    return (
      (items
        ? items.reduce((acc, current) => {
          if (
            current.price &&
            current.quantity &&
            current.state !== "inactive"
          ) {
            return acc + current.price * current.quantity;
          }

          return acc;
        }, 0)
        : 0) +
      eventItems.reduce((acc, current) => {
        if (current.price && current.state !== "inactive") {
          return acc + current.price;
        }

        return acc;
      }, 0)
    );
  }

  getSubtotal() {
    return (
      this.getSubtotalNum().toFixed(2) +
      " " +
      this.props.form.getFieldValue("currency")
    );
  }

  getTotal() {
    const { tax_enabled, tax_amount } = this.props.form.getFieldsValue();

    return (
      (
        this.getSubtotalNum() *
        (tax_enabled && tax_amount ? (100 + tax_amount) / 100 : 1)
      ).toFixed(2) +
      " " +
      this.props.form.getFieldValue("currency")
    );
  }

  getLocalSubtotal() {
    return this.state.exchange && this.state.exchange.exchange_rate
      ? (this.getSubtotalNum() * this.state.exchange.exchange_rate).toFixed(2) +
      " " +
      this.props.form.getFieldValue("local_currency")
      : null;
  }

  render() {
    const {
      isLoading,
      requestResult,
      items,
      exchange,
      exchangeError,
      isLoadingInvoice,
    } = this.state;
    const {
      getFieldDecorator,
      getFieldValue,
      setFieldsValue,
    } = this.props.form;
    const {
      financeInvoiceUpdatePermission,
      financeInvoiceCreatePermission,
      id,
      isNew,
      users,
      sites,
    } = this.props;

    const { isEvents, eventItems } = this.state;

    const isEditable = id
      ? financeInvoiceUpdatePermission
      : financeInvoiceCreatePermission;

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">
            {this.props.id ? (
              <span>
                {this.props.title}{" "}
                <Badge count="Edit" style={{ backgroundColor: "#2968AE" }} />
              </span>
            ) : isNew ? (
              this.props.i18n.t("NamespaceFinanceInvoiceForm:Add invoice")
            ) : (
              ""
            )}
          </h4>

          {!isNew && (
            <Row gutter={12}>
              <Col span={12}>
                <label>
                  <b>Title:</b>
                  <Form.Item>
                    {getFieldDecorator("title", {
                      initialValue: get(this.props, "title", ""),
                    })(<Input disabled={!isEditable} placeholder={this.props.i18n.t("Title")} />)}
                  </Form.Item>
                </label>
              </Col>
            </Row>
          )}

          <Row gutter={12}>
            <Col md={12}>
              <label>
                <b>{this.props.i18n.t("NamespaceFinanceInvoiceForm:Customer")}:</b>
                <Form.Item>
                  {getFieldDecorator("customer_id", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "customer_id"),
                  })(
                    <Select
                      placeholder={this.props.i18n.t("NamespaceFinanceInvoiceForm:Select Customer")}
                      showSearch
                      optionFilterProp="children"
                      filterOption
                    >
                      {users
                        .sort((a, b) => (a.name > b.name ? 1 : a.name === b.name ? 0 : -1))
                        .map((user) => (
                          <Option
                            key={user.id}
                            value={user.id}
                            disabled={!isEditable}
                          >
                            {user.name}
                          </Option>
                        ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
            <Col md={12}>
              <label>
                <b>{this.props.i18n.t("Site")}:</b>
                <Form.Item>
                  {getFieldDecorator("site_id", {
                    rules: [{ required: false, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "site_id"),
                  })(
                    <Select
                      placeholder={this.props.i18n.t("Select Site ID")}
                      style={{ width: "100%" }}
                      allowClear
                      showSearch
                      optionFilterProp="children"
                      filterOption
                      onChange={this.getFinanceInvoiceEventItemListRequest}
                    >
                      {sites
                        .filter((site) => site.site_type === "randomization")
                        .map((site) => (
                          <Option key={site.id} value={site.id}>
                            {site.code} - {site.name}
                          </Option>
                        ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            {!isNew && (
              <Col span={12}>
                <label>
                  <b>{this.props.i18n.t("NamespaceFinanceInvoiceForm:Invoice number")}:</b>
                  <Form.Item>
                    {getFieldDecorator("invoice_number", {
                      initialValue: get(this.props, "invoice_number", ""),
                    })(
                      <Input
                        disabled={!isEditable}
                        placeholder={this.props.i18n.t("NamespaceFinanceInvoiceForm:Invoice number")}
                      />
                    )}
                  </Form.Item>
                </label>
              </Col>
            )}
            <Col span={12}>
              <label>
                <b>{this.props.i18n.t("NamespaceFinanceInvoiceForm:P.O./S.O. number")}:</b>
                <Form.Item>
                  {getFieldDecorator("po_so_number", {
                    initialValue: get(this.props, "po_so_number", ""),
                  })(
                    <Input
                      disabled={!isEditable}
                      placeholder={this.props.i18n.t("NamespaceFinanceInvoiceForm:P.O./S.O. number")}
                    />
                  )}
                </Form.Item>
              </label>
            </Col>

            <Col md={12}>
              <label>
                <b>{this.props.i18n.t("NamespaceFinanceInvoiceForm:Invoice date")}:</b>
              </label>
              <div>
                <Form.Item>
                  <div>
                    {getFieldDecorator("invoice_date", {
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      initialValue: get(this.props, "invoice_date")
                        ? moment(get(this.props, "invoice_date"))
                        : null,
                    })(
                      <DatePicker
                        disabled={!isEditable}
                        format="YYYY/MM/DD"
                        placeholder="yyyy-mm-dd"
                        showToday={false}
                      />
                    )}
                  </div>
                </Form.Item>
              </div>
            </Col>

            <Col md={12}>
              <label>
                <b>{this.props.i18n.t("NamespaceFinanceInvoiceForm:Payment due")}:</b>
              </label>
              <div>
                <Form.Item>
                  <div>
                    {getFieldDecorator("payment_due_date", {
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      initialValue: get(this.props, "payment_due_date")
                        ? moment(get(this.props, "payment_due_date"))
                        : null,
                    })(
                      <DatePicker
                        disabled={!isEditable}
                        format="YYYY/MM/DD"
                        placeholder="yyyy-mm-dd"
                        showToday={false}
                      />
                    )}
                  </div>
                </Form.Item>
              </div>
            </Col>

            <Col span={24}>
              <label>
                <b>{this.props.i18n.t("Comments")}:</b>
                <Form.Item style={{ marginBottom: "12px" }}>
                  {getFieldDecorator(`comments`, {
                    initialValue: get(this.props, "comments", ""),
                  })(
                    <Input.TextArea
                      disabled={!isEditable}
                      placeholder={this.props.i18n.t("Comments")}
                    />
                  )}
                </Form.Item>
              </label>
            </Col>

            <Col span={24}>
              <label>
                <b>{this.props.i18n.t("NamespaceFinanceInvoiceForm:Footer notes")}:</b>
                <Form.Item style={{ marginBottom: "12px" }}>
                  {getFieldDecorator(`footer_notes`, {
                    initialValue: get(this.props, "footer_notes", ""),
                  })(
                    <Input.TextArea
                      disabled={!isEditable}
                      placeholder={this.props.i18n.t("NamespaceFinanceInvoiceForm:Footer notes")}
                    />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <h5 style={{ marginTop: "24px" }}>Bill to</h5>

          <Col span={24}>
            <label>
              {getFieldDecorator("custom_bill_to_enabled", {
                initialValue:
                  get(this.props, "custom_bill_to_enabled", false) === null
                    ? false
                    : get(this.props, "custom_bill_to_enabled", false),
                valuePropName: "checked",
              })(
                <Checkbox disabled={!isEditable}>
                  {this.props.i18n.t("NamespaceFinanceInvoiceForm:Custom bill to enabled")}
                </Checkbox>
              )}
            </label>
          </Col>

          {getFieldValue("custom_bill_to_enabled") !== null &&
            getFieldValue("custom_bill_to_enabled") !== false && (
              <Col span={24}>
                <label>
                  <b>{this.props.i18n.t("NamespaceFinanceInvoiceForm:Bill to")}:</b>
                  <Form.Item>
                    {getFieldDecorator("custom_bill_to", {
                      rules: [{ required: true, message: this.props.i18n.t("Required") }],
                      initialValue: get(this.props, "custom_bill_to", null),
                    })(
                      <Input.TextArea
                        disabled={!isEditable}
                        placeholder={this.props.i18n.t("NamespaceFinanceInvoiceForm:custom bill to")}
                      />
                    )}
                  </Form.Item>
                </label>
              </Col>
            )}
          <br />
          <br />

          <h4 style={{ margin: "12px 0 0" }}>
            <span
              className={classNames(classes.eventToggler, {
                [classes.eventTogglerActive]: isEvents,
              })}
              onClick={() => {
                this.setState({ isEvents: false });
              }}
            >
              {this.props.i18n.t("NamespaceFinanceInvoiceForm:Items")}
            </span>

            {id && (
              <span
                className={classNames(classes.eventToggler, {
                  [classes.eventTogglerActive]: !isEvents,
                })}
                onClick={() => {
                  this.setState({ isEvents: true });
                }}
              >
                {this.props.i18n.t("NamespaceFinanceInvoiceForm:Events")}
              </span>
            )}
          </h4>

          <div style={{ display: !isEvents ? "none" : "block" }}>
            <Row style={{ margin: "12px 0" }}>
              <Col span={4}>
                <b>
                  {this.props.i18n.t(
                    "NamespaceFinanceInvoiceForm:Subject Profile"
                  )}
                  :
                </b>
              </Col>

              <Col span={4}>
                <b>
                  {this.props.i18n.t("NamespaceFinanceInvoiceForm:Event Name")}:
                </b>
              </Col>

              <Col span={4}>
                <b>{this.props.i18n.t("NamespaceFinanceInvoiceForm:Price")}:</b>
              </Col>

              <Col span={4}>
                <b>
                  {this.props.i18n.t(
                    "NamespaceFinanceInvoiceForm:Event Status"
                  )}
                  :
                </b>
              </Col>

              <Col span={4}>
                <b>{this.props.i18n.t("Site")}:</b>
              </Col>

              <Col span={4}>
                <b>{this.props.i18n.t("NamespaceFinanceInvoiceForm:Attach Event")}:</b>
              </Col>
            </Row>
            {eventItems.map((item, i) => (
              <div
                key={i}
                style={{ padding: "12px 0 10px", borderTop: "1px solid #eee" }}
              >
                <Row>
                  <Col span={4}>{get(item, "subject.code")}</Col>

                  <Col span={4}>{get(item, "event.name")}</Col>

                  <Col span={4}>
                    {get(item, "price_event.price").toFixed(2)}{" "}
                    {get(item, "price_event.price_currency")}
                  </Col>
                  <Col span={4}>{item.status}</Col>
                  <Col span={4}>
                    {get(
                      find(sites, (s) => s.id === item.site_id),
                      "code"
                    )}
                    {" "}-{" "}
                    {get(
                      find(sites, (s) => s.id === item.site_id),
                      "name"
                    )}
                  </Col>

                  <Col span={4}>
                    <div style={{ display: "flex", width: "110px" }}>
                      <Tooltip
                        placement="topLeft"
                        title={this.props.i18n.t("NamespaceFinanceInvoiceForm:Attach / Detach")}
                      >
                        <Switch
                          checked={item.state === "active"}
                          onChange={this.onSwitchInvoiceEventTypeActivation(
                            item.id,
                            item.state,
                            i
                          )}
                        />
                      </Tooltip>
                      &nbsp;&nbsp;
                      {item.invoice_id !== this.props.id && (
                        <Tag color="green">{this.props.i18n.t("NamespaceFinanceInvoiceForm:New")}</Tag>
                      )}
                    </div>
                  </Col>
                </Row>
              </div>
            ))}

            {isLoadingInvoice && (
              <div className={classes.isLoadingWrapper}>
                <Icon type="loading" />
              </div>
            )}
          </div>

          <div style={{ display: isEvents ? "none" : "block" }}>
            {items.length === 0 && <div>{this.props.i18n.t("NamespaceFinanceInvoiceForm:No items")}</div>}
            <div>
              {items.map(
                (item, i) =>
                  item && (
                    <div key={i} className={classes.invoiceItem}>
                      <Row gutter={12}>
                        {item.id && (
                          <Form.Item style={{ display: "none" }}>
                            {getFieldDecorator(`items[${i}].id`, {
                              initialValue: item.id,
                            })(<Input disabled />)}
                          </Form.Item>
                        )}
                        {item.id && (
                          <Form.Item style={{ display: "none" }}>
                            {getFieldDecorator(`items[${i}].state`, {
                              initialValue: item.state,
                            })(<Input disabled />)}
                          </Form.Item>
                        )}
                        <Col span={12}>
                          <label>
                            <b>{this.props.i18n.t("NamespaceFinanceInvoiceForm:Title")}:</b>
                            <Form.Item style={{ marginBottom: "12px" }}>
                              {getFieldDecorator(`items[${i}].title`, {
                                rules: [
                                  { required: true, message: this.props.i18n.t("Required") },
                                ],
                                initialValue: item.title,
                              })(
                                <Input
                                  disabled={!isEditable}
                                  placeholder={this.props.i18n.t("NamespaceFinanceInvoiceForm:Title")}
                                />
                              )}
                            </Form.Item>
                          </label>
                        </Col>
                        {item.id && (
                          <Col span={12}>
                            <div style={{ marginBottom: "6px" }}>State</div>
                            <Tooltip
                              placement="topLeft"
                              title={this.props.i18n.t("NamespaceFinanceInvoiceForm:Activate / Deactivate Invoice item")}
                            >
                              <Switch
                                checked={item.state === "active"}
                                onChange={this.onSwitchInvoiceActivation(
                                  item.id,
                                  item.state,
                                  i
                                )}
                              />
                            </Tooltip>
                          </Col>
                        )}
                        {!item.id && (
                          <Col span={12}>
                            <b>&nbsp;</b>
                            <div style={{ marginTop: "10px" }}>
                              <DeleteOutlined
                                onClick={() => {
                                  const items = [...this.state.items];
                                  setFieldsValue({
                                    [`items[${i}].price`]: null,
                                    [`items[${i}].quantity`]: null,
                                  });
                                  items.splice(i, 1, null);
                                  this.setState({ items });
                                }}
                              />
                            </div>
                          </Col>
                        )}
                      </Row>

                      <Row gutter={12}>
                        <Col span={6}>
                          <label>
                            <b>{this.props.i18n.t("Quantity")}:</b>
                            <Form.Item style={{ marginBottom: "12px" }}>
                              {getFieldDecorator(`items[${i}].quantity`, {
                                rules: [
                                  { required: true, message: this.props.i18n.t("Required") },
                                ],
                                initialValue: item.quantity,
                              })(
                                <InputNumber
                                  disabled={!isEditable}
                                  placeholder={"1"}
                                />
                              )}
                            </Form.Item>
                          </label>
                        </Col>

                        <Col span={6}>
                          <label>
                            <b>{this.props.i18n.t("NamespaceFinanceInvoiceForm:Price")}:</b>
                            <Form.Item style={{ marginBottom: "12px" }}>
                              {getFieldDecorator(`items[${i}].price`, {
                                rules: [
                                  { required: true, message: this.props.i18n.t("Required") },
                                ],
                                initialValue: item.price,
                              })(
                                <InputNumber
                                  disabled={!isEditable}
                                  placeholder={"10"}
                                />
                              )}
                            </Form.Item>
                          </label>
                        </Col>

                        <Col span={6}>
                          <label>
                            <b>{this.props.i18n.t("NamespaceFinanceInvoiceForm:Amount")}:</b>
                            <Form.Item style={{ marginBottom: "12px" }}>
                              {getFieldValue(`items[${i}].quantity`) &&
                                getFieldValue(`items[${i}].price`) && (
                                  <span>
                                    {(
                                      getFieldValue(`items[${i}].quantity`) *
                                      getFieldValue(`items[${i}].price`)
                                    ).toFixed(2)}
                                    &nbsp;
                                    {getFieldValue("currency")}
                                  </span>
                                )}
                            </Form.Item>
                          </label>
                        </Col>

                        <Col span={24}>
                          <label>
                            <b>{this.props.i18n.t("NamespaceFinanceInvoiceForm:Summary")}:</b>
                            <Form.Item style={{ marginBottom: "12px" }}>
                              {getFieldDecorator(`items[${i}].summary`, {
                                rules: [
                                  { required: true, message: this.props.i18n.t("Required") },
                                ],
                                initialValue: item.summary,
                              })(
                                <Input.TextArea
                                  disabled={!isEditable}
                                  placeholder={this.props.i18n.t("NamespaceFinanceInvoiceForm:Summary")}
                                />
                              )}
                            </Form.Item>
                          </label>
                        </Col>
                      </Row>
                    </div>
                  )
              )}
            </div>

            <Row
              gutter={12}
              style={{
                padding: "12px 0",
                marginBottom: "24px",
                borderBottom: "1px solid #eee",
              }}
            >
              <Col span={12}>
                <Button
                  type="primary"
                  size="small"
                  htmlType="button"
                  onClick={() => {
                    this.setState({ items: [...items, {}] });
                  }}
                >
                  <PlusCircleOutlined />
                  {this.props.i18n.t("NamespaceFinanceInvoiceForm:Add item")}
                </Button>
              </Col>
            </Row>
          </div>

          <h5 style={{ marginTop: "24px" }}>{this.props.i18n.t("NamespaceFinanceInvoiceForm:Taxes")}</h5>

          <Row gutter={12}>
            <Col span={24}>
              <label>
                {getFieldDecorator("tax_enabled", {
                  initialValue:
                    get(this.props, "tax_enabled", false) === null
                      ? false
                      : get(this.props, "tax_enabled", false),
                  valuePropName: "checked",
                })(<Checkbox disabled={!isEditable}>{this.props.i18n.t("NamespaceFinanceInvoiceForm:Tax enabled")}</Checkbox>)}
              </label>
            </Col>
          </Row>
          <br />

          {getFieldValue("tax_enabled") !== null &&
            getFieldValue("tax_enabled") !== false && (
              <Row gutter={12}>
                <Col>
                  <label>
                    <b>{this.props.i18n.t("NamespaceFinanceInvoiceForm:Tax %")}:</b>
                    <Form.Item>
                      {getFieldDecorator("tax_amount", {
                        initialValue: get(this.props, "tax_amount", 0),
                      })(
                        <InputNumber
                          disabled={!isEditable}
                          placeholder={this.props.i18n.t("NamespaceFinanceInvoiceForm:Tax %")}
                        />
                      )}
                    </Form.Item>
                  </label>
                </Col>
                <Col>
                  <label>
                    <b>{this.props.i18n.t("NamespaceFinanceInvoiceForm:Tax ID/Code")}:</b>
                    <Form.Item>
                      {getFieldDecorator("tax_code", {
                        initialValue: get(this.props, "tax_code", ""),
                      })(
                        <Input
                          disabled={!isEditable}
                          placeholder={this.props.i18n.t("NamespaceFinanceInvoiceForm:Tax ID/Code")}
                        />
                      )}
                    </Form.Item>
                  </label>
                </Col>
              </Row>
            )}

          <h5>{this.props.i18n.t("Currency")}</h5>

          <Row gutter={12} style={{ margin: "12px 0 24px" }}>
            <Col md={12}>
              <label>
                <b>{this.props.i18n.t("Currency")}</b>
                <Form.Item>
                  {getFieldDecorator("currency", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "currency", ""),
                  })(
                    <Select
                      disabled={!isEditable}
                      onChange={this.financeExchange}
                    >
                      {currencies.map((currency) => (
                        <Option
                          value={currency}
                          /*disabled={
                            currency === getFieldValue("local_currency")
                          }*/
                          key={currency}
                        >
                          {currency}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>

            <Col md={12}>
              <b>{this.props.i18n.t("Total")}</b>
              <div style={{ marginTop: "9px", fontFamily: "Arial" }}>
                <b>{this.getSubtotal()}</b>
              </div>
            </Col>
          </Row>

          <Row gutter={12} style={{ margin: "12px 0 24px" }}>
            <Col md={12}>
              <label>
                <b>{this.props.i18n.t("NamespaceFinanceInvoiceForm:Local Currency")}</b>
                <Form.Item>
                  {getFieldDecorator("local_currency", {
                    initialValue: get(this.props, "local_currency", null),
                  })(
                    <Select
                      disabled={!isEditable}
                      onChange={this.financeExchange}
                    >
                      <Option value={null}>{this.props.i18n.t("NamespaceFinanceInvoiceForm:None")}</Option>
                      {currencies.map((currency) => (
                        <Option
                          value={currency}
                          // disabled={currency === getFieldValue("currency")}
                          key={currency}
                        >
                          {currency}
                        </Option>
                      ))}
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
            {getFieldValue("local_currency") !== null && (
              <Col md={12}>
                <b>{this.props.i18n.t("NamespaceFinanceInvoiceForm:Total (Local Currency)")}</b>
                <div style={{ marginTop: "9px", fontFamily: "Arial" }}>
                  <b>
                    {this.getLocalSubtotal() ||
                      (!exchangeError && <LoadingOutlined />)}
                  </b>
                </div>
              </Col>
            )}
          </Row>

          {exchangeError && (
            <Alert
              type="error"
              message={exchangeError}
              style={{ margin: "0 0 24px" }}
            />
          )}

          {getFieldValue("local_currency") !== null && exchange && (
            <Row gutter={12} style={{ margin: "12px 0 24px" }}>
              <Col md={24}>
                <b>{this.props.i18n.t("Note")}:</b>
                <div style={{ marginTop: "9px", fontFamily: "Arial" }}>
                  <i>
                    {this.props.i18n.t("This is the estimate cost in the local currency as of")}{" "}
                    {exchange.date}{" "}{this.props.i18n.t(`date. Please note that your cost may be
                    different based on the transaction date and currency
                    fluctuations. Please pay amount in invoice currency`)}{" "}({getFieldValue("currency")})
                  </i>
                </div>
              </Col>
            </Row>
          )}

          <Row gutter={12} style={{ margin: "12px 0 24px" }}>
            <Col md={12}>
              <b>{this.props.i18n.t("Subtotal")}</b>
              <div style={{ marginTop: "9px", fontFamily: "Arial" }}>
                <b>{this.getSubtotal()}</b>
              </div>
            </Col>
          </Row>

          <Row gutter={12} style={{ margin: "0 0 24px" }}>
            <Col md={12}>
              <h5>{this.props.i18n.t("Total")}</h5>
              <div style={{ marginTop: "9px", fontFamily: "Arial" }}>
                <b>{this.getTotal()}</b>
              </div>
            </Col>
          </Row>

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            {isEditable && (
              <Form.Item>
                <Button
                  type="primary"
                  size="large"
                  htmlType="submit"
                  className={classes.submitButton}
                  disabled={isLoadingInvoice}
                >
                  {this.props.i18n.t("Save")}
                  {isLoading && <Icon type="loading" />}
                </Button>
                &nbsp; &nbsp;
              </Form.Item>
            )}

            <Button
              type="default"
              size="large"
              htmlType="button"
              className={classes.submitButton}
              onClick={this.props.onCancel}
              disabled={isLoadingInvoice || isLoading}
            >
              {this.props.i18n.t("Cancel")}
            </Button>
          </div>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  financeInvoiceCreatePermission: getFinanceInvoiceCreatePermission(state),
  financeInvoiceUpdatePermission: getFinanceInvoiceUpdatePermission(state),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "customer" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(FinanceInvoiceForm))
);



// WEBPACK FOOTER //
// ./src/components/FinanceInvoiceForm/FinanceInvoiceForm.js